import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function RecoveryScreen({ onRecover, onBack }) {
  const { t } = useTranslation();
  const [pin, setPin] = useState('');
  const [error, setError] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    const result = onRecover(pin.trim());
    if (result === 'ok') return;
    if (result === 'no-session') setError(t('recovery.noSession'));
    else if (result === 'wrong-pin') setError(t('recovery.wrongPin'));
    else setError(t('recovery.serverFallback'));
  }

  return (
    <div style={s.card}>
      <h1 style={s.title}>{t('recovery.title')}</h1>
      <p style={s.subtitle}>{t('recovery.subtitle')}</p>

      <form onSubmit={handleSubmit} style={s.form}>
        <input
          type="text"
          inputMode="numeric"
          maxLength={4}
          value={pin}
          onChange={e => { setPin(e.target.value.replace(/\D/g, '')); setError(null); }}
          placeholder={t('recovery.pinPlaceholder')}
          style={{ ...s.input, ...(error ? s.inputError : {}), textAlign: 'center', letterSpacing: '0.4em', fontSize: '1.5rem' }}
          autoFocus
        />
        {error && <p style={s.errorMsg}>{error}</p>}
        <button type="submit" style={s.primaryBtn} disabled={pin.length !== 4}>
          {t('recovery.submitButton')}
        </button>
      </form>

      <button type="button" onClick={onBack} style={s.linkBtn}>
        {t('recovery.backLink')}
      </button>
    </div>
  );
}

const s = {
  card: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, width: '100%' },
  title: { fontSize: '1.75rem', fontWeight: 700, margin: 0, color: '#F8FAFC' },
  subtitle: { fontSize: '0.9rem', color: '#94A3B8', margin: 0, textAlign: 'center' },
  form: { display: 'flex', flexDirection: 'column', gap: 10, width: '100%' },
  input: {
    fontSize: '1rem', padding: '14px', borderRadius: 10,
    border: '1px solid #334155', outline: 'none', width: '100%', boxSizing: 'border-box',
    background: '#1E293B', color: '#F8FAFC',
  },
  inputError: { border: '1.5px solid #EF4444' },
  errorMsg: { margin: 0, fontSize: '0.8rem', color: '#EF4444' },
  primaryBtn: {
    fontSize: '1rem', fontWeight: 600, padding: '13px', borderRadius: 12,
    border: 'none', background: '#7C3AED', color: '#fff', cursor: 'pointer',
    width: '100%', opacity: 1, transition: 'opacity 0.15s',
  },
  linkBtn: {
    background: 'none', border: 'none', color: '#7C3AED',
    fontSize: '0.875rem', cursor: 'pointer', textDecoration: 'underline',
  },
};
